import script from "./DocumentStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DocumentStatistics.vue?vue&type=style&index=0&id=4c5b5d38&scoped=true&lang=css"
import "./DocumentStatistics.vue?vue&type=style&index=1&id=4c5b5d38&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5b5d38"]])

export default __exports__